import React, { useEffect, useMemo, useState } from "react";

const API_BASE = "https://ffqadir.az/backendtest_9/api";

const CATEGORY_API = `${API_BASE}/categoryy`;
const PRODUCTS_API = `${API_BASE}/fans`;

const WHATSAPP_NUMBER = "994702267778";

const PRODUCTS_PER_LOAD = 100;

function MobileAccessory() {
  const [categories, setCategories] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  const [selectedCategories, setSelectedCategories] = useState([]);

  const [displayedCount, setDisplayedCount] =
    useState(PRODUCTS_PER_LOAD);

  const [loadingCategories, setLoadingCategories] =
    useState(true);

  const [loadingProducts, setLoadingProducts] =
    useState(false);

  const [error, setError] = useState("");

  const [categoryOpen, setCategoryOpen] = useState(false);

  const shuffleArray = (array) => {
    const shuffled = [...array];

    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));

      [shuffled[i], shuffled[j]] = [
        shuffled[j],
        shuffled[i],
      ];
    }

    return shuffled;
  };

  const fetchCategories = async () => {
    try {
      setLoadingCategories(true);
      setError("");

      const response = await fetch(CATEGORY_API);

      if (!response.ok) {
        throw new Error("Kateqoriyalar yüklənmədi");
      }

      const data = await response.json();

      if (Array.isArray(data?.allKart)) {
        setCategories(data.allKart);
      } else {
        setCategories([]);
        setError("Kateqoriyalar yüklənmədi.");
      }
    } catch (err) {
      console.error("Kategoriya çekme hatası:", err);

      setCategories([]);
      setError(
        "Kateqoriyalar yüklənərkən xəta baş verdi."
      );
    } finally {
      setLoadingCategories(false);
    }
  };

  const fetchCategoryProducts = async (category) => {
    try {
      const response = await fetch(
        `${PRODUCTS_API}/${encodeURIComponent(category)}`
      );

      if (!response.ok) {
        return [];
      }

      const data = await response.json();

      if (Array.isArray(data?.allFan)) {
        return data.allFan;
      }

      return [];
    } catch (err) {
      console.error(
        `Məhsullar yüklənmədi: ${category}`,
        err
      );

      return [];
    }
  };

  const fetchAllCategoryProducts = async (
    categoryList
  ) => {
    if (!categoryList.length) {
      return [];
    }

    const results = await Promise.all(
      categoryList.map((category) =>
        fetchCategoryProducts(category)
      )
    );

    return results.flat();
  };

  const fetchRandomProducts = async () => {
    try {
      setLoadingProducts(true);
      setError("");

      setDisplayedCount(PRODUCTS_PER_LOAD);

      const categoryTitles = categories
        .map((category) => category?.title)
        .filter(Boolean);

      if (!categoryTitles.length) {
        setAllProducts([]);
        return;
      }

      const products =
        await fetchAllCategoryProducts(categoryTitles);

      const shuffled = shuffleArray(products);

      setAllProducts(shuffled);
    } catch (err) {
      console.error(
        "Ürünləri rastgele çekerken hata oluştu:",
        err
      );

      setAllProducts([]);
      setError(
        "Məhsullar yüklənərkən xəta baş verdi."
      );
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchSelectedCategoriesProducts = async (
    selected
  ) => {
    if (!selected.length) {
      await fetchRandomProducts();
      return;
    }

    try {
      setLoadingProducts(true);
      setError("");

      setDisplayedCount(PRODUCTS_PER_LOAD);

      const products =
        await fetchAllCategoryProducts(selected);

      const shuffled = shuffleArray(products);

      setAllProducts(shuffled);
    } catch (err) {
      console.error(
        "Seçilmiş kateqoriyalardan məhsul xətası:",
        err
      );

      setAllProducts([]);
      setError(
        "Məhsullar yüklənərkən xəta baş verdi."
      );
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (categories.length > 0) {
      fetchRandomProducts();
    }
  }, [categories]);

  const displayedProducts = useMemo(() => {
    return allProducts.slice(0, displayedCount);
  }, [allProducts, displayedCount]);

  const handleLoadMore = () => {
    setDisplayedCount(
      (prev) => prev + PRODUCTS_PER_LOAD
    );
  };

  const handleCategoryChange = (categoryTitle) => {
    setSelectedCategories((prev) => {
      const exists = prev.includes(categoryTitle);

      const updated = exists
        ? prev.filter(
            (category) => category !== categoryTitle
          )
        : [...prev, categoryTitle];

      fetchSelectedCategoriesProducts(updated);

      return updated;
    });
  };

  const handleClearCategories = () => {
    if (selectedCategories.length > 0) {
      setSelectedCategories([]);
      fetchRandomProducts();
    }
  };

  const handleOrder = (product) => {
    const message = `Merhaba, ${product.title} ürününü satın almak istiyorum.`;

    const whatsappUrl =
      `https://api.whatsapp.com/send/?phone=%2B${WHATSAPP_NUMBER}` +
      `&text=${encodeURIComponent(message)}` +
      `&type=phone_number&app_absent=0`;

    window.open(
      whatsappUrl,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div
      className="
        relative
        min-h-screen
        overflow-x-hidden
        bg-[#f5f7fb]
        text-slate-900
        transition-colors
        duration-500
        dark:bg-[#040209]
        dark:text-white
      "
    >
      {/* =========================================================
          BACKGROUND GRID - LIGHT
      ========================================================= */}
      <div
        className="
          pointer-events-none
          fixed
          inset-0
          z-0
          opacity-60
          dark:hidden
        "
        style={{
          backgroundImage: `
            linear-gradient(
              to right,
              rgba(100,116,139,0.055) 1px,
              transparent 1px
            ),
            linear-gradient(
              to bottom,
              rgba(100,116,139,0.055) 1px,
              transparent 1px
            )
          `,
          backgroundSize: "40px 40px",
        }}
      />

      {/* =========================================================
          BACKGROUND GRID - DARK
      ========================================================= */}
      <div
        className="
          pointer-events-none
          fixed
          inset-0
          z-0
          hidden
          dark:block
        "
        style={{
          backgroundImage: `
            linear-gradient(
              to right,
              rgba(255,255,255,0.025) 1px,
              transparent 1px
            ),
            linear-gradient(
              to bottom,
              rgba(255,255,255,0.025) 1px,
              transparent 1px
            )
          `,
          backgroundSize: "40px 40px",
        }}
      />

      {/* =========================================================
          BACKGROUND GLOW
      ========================================================= */}
      <div
        className="
          pointer-events-none
          fixed
          -left-40
          -top-40
          hidden
          h-[420px]
          w-[420px]
          rounded-full
          bg-indigo-400/10
          blur-[140px]
          md:block
          dark:bg-indigo-600/10
        "
      />

      <div
        className="
          pointer-events-none
          fixed
          -right-40
          top-1/2
          hidden
          h-[420px]
          w-[420px]
          rounded-full
          bg-purple-400/10
          blur-[140px]
          md:block
          dark:bg-purple-600/10
        "
      />

      {/* =========================================================
          MAIN
      ========================================================= */}
      <main
        className="
          relative
          z-10
          min-h-screen
          py-2
          sm:py-4
          lg:py-6
        "
      >
        {/* =======================================================
            FULL WIDTH DESKTOP CONTAINER
        ======================================================= */}
        <div
          className="
            w-full
            px-2
            sm:px-4
            lg:px-6
            xl:px-8
          "
        >
          <div
            className="
              w-full
              overflow-hidden
              rounded-[1.4rem]
              border
              border-slate-200
              bg-white
              shadow-[0_20px_70px_rgba(15,23,42,0.08)]
              transition-colors
              duration-500
              sm:rounded-3xl
              dark:border-white/[0.08]
              dark:bg-[#0D081D]/95
              dark:shadow-[0_20px_80px_rgba(0,0,0,0.45)]
            "
          >
            {/* =====================================================
                HEADER
            ===================================================== */}
            <div
              className="
                border-b
                border-slate-200
                bg-gradient-to-r
                from-indigo-50
                via-purple-50/50
                to-transparent
                p-3.5
                transition-colors
                duration-500
                sm:p-6
                lg:p-8
                dark:border-white/[0.08]
                dark:from-indigo-500/[0.06]
                dark:via-purple-500/[0.04]
                dark:to-transparent
              "
            >
              <div
                className="
                  flex
                  items-center
                  justify-between
                  gap-3
                "
              >
                {/* TITLE */}
                <div className="min-w-0">
                  <div
                    className="
                      flex
                      items-center
                      gap-2.5
                    "
                  >
                    <span
                      className="
                        h-7
                        w-1
                        shrink-0
                        rounded-full
                        bg-gradient-to-b
                        from-indigo-400
                        to-purple-500
                        shadow-[0_0_16px_rgba(99,102,241,0.5)]
                        sm:h-8
                        sm:w-1.5
                      "
                    />

                    <h1
                      className="
                        truncate
                        text-lg
                        font-black
                        tracking-tight
                        text-slate-900
                        sm:text-2xl
                        lg:text-3xl
                        dark:text-white
                      "
                    >
                      Mobil Aksesuarlar
                    </h1>
                  </div>

                  <p
                    className="
                      mt-1.5
                      ml-3.5
                      max-w-xl
                      text-[10px]
                      leading-5
                      text-slate-500
                      sm:text-sm
                      dark:text-gray-400
                    "
                  >
                    Telefonunuz üçün uyğun aksesuarları
                    seçin və sifariş edin.
                  </p>
                </div>

                {/* DESKTOP CATEGORY BUTTON */}
                <button
                  type="button"
                  onClick={() =>
                    setCategoryOpen((prev) => !prev)
                  }
                  className="
                    hidden
                    min-h-[40px]
                    shrink-0
                    items-center
                    justify-center
                    gap-2
                    rounded-xl
                    border
                    border-indigo-200
                    bg-indigo-50
                    px-3
                    text-xs
                    font-black
                    text-indigo-700
                    transition-all
                    active:scale-[0.98]
                    hover:border-indigo-300
                    hover:bg-indigo-100
                    lg:flex
                    sm:min-h-[44px]
                    sm:rounded-2xl
                    sm:px-4
                    sm:text-sm
                    dark:border-indigo-500/30
                    dark:bg-indigo-500/10
                    dark:text-white
                    dark:hover:bg-indigo-500/20
                  "
                >
                  <svg
                    className="h-4 w-4 sm:h-5 sm:w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      d="M4 6h16M4 12h16M4 18h16"
                      strokeLinecap="round"
                    />
                  </svg>

                  <span className="hidden sm:inline">
                    Kategoriyalar
                  </span>

                  <svg
                    className={`
                      h-3.5
                      w-3.5
                      transition-transform
                      duration-200
                      ${
                        categoryOpen
                          ? "rotate-180"
                          : ""
                      }
                    `}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      d="m6 9 6 6 6-6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* =====================================================
                DESKTOP OVERLAY
            ===================================================== */}
            {categoryOpen && (
              <div
                className="
                  fixed
                  inset-0
                  z-[90]
                  hidden
                  bg-black/20
                  backdrop-blur-[2px]
                  lg:block
                  dark:bg-black/45
                "
                onClick={() => setCategoryOpen(false)}
                aria-hidden="true"
              />
            )}

            {/* =====================================================
                DESKTOP CATEGORY DRAWER
                RIGHT -> LEFT
            ===================================================== */}
            <aside
              className={`
                fixed
                right-0
                top-0
                z-[100]
                hidden
                h-screen
                w-[380px]
                max-w-[92vw]
                overflow-y-auto
                border-l
                border-slate-200
                bg-white/98
                shadow-[-20px_0_60px_rgba(15,23,42,0.16)]
                backdrop-blur-2xl
                transition-transform
                duration-300
                ease-out
                lg:block
                dark:border-white/[0.08]
                dark:bg-[#080510]/98
                dark:shadow-[-20px_0_60px_rgba(0,0,0,0.55)]
                ${
                  categoryOpen
                    ? "translate-x-0"
                    : "translate-x-full"
                }
              `}
            >
              {/* DRAWER HEADER */}
              <div
                className="
                  sticky
                  top-0
                  z-20
                  flex
                  items-center
                  justify-between
                  border-b
                  border-slate-200
                  bg-white/95
                  px-4
                  py-3
                  backdrop-blur-xl
                  dark:border-white/[0.08]
                  dark:bg-[#080510]/95
                "
              >
                <div>
                  <span
                    className="
                      text-sm
                      font-black
                      text-slate-900
                      dark:text-white
                    "
                  >
                    Kateqoriyalar
                  </span>

                  <p
                    className="
                      mt-0.5
                      text-[10px]
                      text-slate-500
                      dark:text-gray-500
                    "
                  >
                    Məhsul kateqoriyası seçin
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => setCategoryOpen(false)}
                  aria-label="Kateqoriyaları bağla"
                  className="
                    flex
                    h-9
                    w-9
                    items-center
                    justify-center
                    rounded-full
                    border
                    border-slate-200
                    bg-slate-50
                    text-slate-500
                    transition-all
                    hover:rotate-90
                    hover:bg-slate-100
                    hover:text-slate-900
                    active:scale-95
                    dark:border-white/[0.08]
                    dark:bg-white/[0.04]
                    dark:text-gray-300
                    dark:hover:bg-white/[0.08]
                    dark:hover:text-white
                  "
                >
                  <svg
                    className="h-4 w-4"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      d="m6 6 12 12M18 6 6 18"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>

              {/* DRAWER CONTENT */}
              <div
                className="
                  p-4
                  sm:p-5
                "
              >
                {/* CLEAR */}
                <div
                  className="
                    mb-4
                    flex
                    items-center
                    justify-between
                    gap-3
                  "
                >
                  <div>
                    <p
                      className="
                        text-xs
                        font-bold
                        text-slate-500
                        dark:text-gray-400
                      "
                    >
                      Seçilmiş kateqoriyalar
                    </p>

                    <p
                      className="
                        mt-0.5
                        text-[10px]
                        text-slate-400
                        dark:text-gray-600
                      "
                    >
                      Bir və ya bir neçə seçim edə bilərsiniz.
                    </p>
                  </div>

                  {selectedCategories.length > 0 && (
                    <button
                      type="button"
                      onClick={handleClearCategories}
                      className="
                        shrink-0
                        rounded-lg
                        px-2
                        py-1
                        text-[10px]
                        font-bold
                        text-rose-500
                        transition
                        hover:bg-rose-500/10
                        hover:text-rose-400
                      "
                    >
                      Təmizlə
                    </button>
                  )}
                </div>

                {/* ALL BUTTON */}
                <button
                  type="button"
                  onClick={handleClearCategories}
                  className={`
                    mb-4
                    flex
                    w-full
                    items-center
                    justify-between
                    rounded-xl
                    border
                    px-3.5
                    py-3
                    text-left
                    transition-all
                    ${
                      selectedCategories.length === 0
                        ? "border-indigo-400 bg-indigo-50 text-indigo-700 dark:border-indigo-400/60 dark:bg-indigo-500/10 dark:text-white"
                        : "border-slate-200 bg-slate-50 text-slate-600 hover:border-indigo-300 hover:bg-indigo-50/60 dark:border-white/[0.08] dark:bg-white/[0.02] dark:text-gray-300 dark:hover:border-indigo-500/30"
                    }
                  `}
                >
                  <span
                    className="
                      text-xs
                      font-black
                    "
                  >
                    Bütün kateqoriyalar
                  </span>

                  {selectedCategories.length === 0 && (
                    <svg
                      className="h-4 w-4 text-indigo-500 dark:text-indigo-400"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                    >
                      <path
                        d="m5 12 4 4L19 6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>

                {/* LOADING CATEGORIES */}
                {loadingCategories ? (
                  <div
                    className="
                      flex
                      items-center
                      gap-3
                      rounded-xl
                      border
                      border-slate-200
                      bg-slate-50
                      p-4
                      text-xs
                      text-slate-500
                      dark:border-white/[0.08]
                      dark:bg-white/[0.02]
                      dark:text-gray-400
                    "
                  >
                    <svg
                      className="h-5 w-5 animate-spin text-indigo-400"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="9"
                        stroke="currentColor"
                        strokeWidth="3"
                        opacity="0.25"
                      />

                      <path
                        d="M21 12a9 9 0 0 1-9 9"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                    </svg>

                    Kateqoriyalar yüklənir...
                  </div>
                ) : categories.length === 0 ? (
                  <div
                    className="
                      rounded-xl
                      border
                      border-slate-200
                      bg-slate-50
                      p-4
                      text-xs
                      text-slate-500
                      dark:border-white/[0.08]
                      dark:bg-white/[0.02]
                      dark:text-gray-500
                    "
                  >
                    Kateqoriya tapılmadı.
                  </div>
                ) : (
                  <div className="space-y-2">
                    {categories.map((category) => {
                      const categoryTitle =
                        category?.title;

                      if (!categoryTitle) {
                        return null;
                      }

                      const checked =
                        selectedCategories.includes(
                          categoryTitle
                        );

                      return (
                        <label
                          key={String(
                            category._id ||
                              categoryTitle
                          )}
                          className={`
                            group
                            flex
                            cursor-pointer
                            items-center
                            gap-3
                            rounded-xl
                            border
                            p-3
                            transition-all
                            duration-200
                            ${
                              checked
                                ? "border-indigo-400 bg-indigo-50 shadow-sm dark:border-indigo-400/60 dark:bg-indigo-500/10 dark:shadow-[0_0_20px_rgba(99,102,241,0.12)]"
                                : "border-slate-200 bg-white hover:border-indigo-300 hover:bg-indigo-50/50 dark:border-white/[0.08] dark:bg-white/[0.02] dark:hover:border-indigo-500/30 dark:hover:bg-white/[0.04]"
                            }
                          `}
                        >
                          <input
                            type="checkbox"
                            value={categoryTitle}
                            checked={checked}
                            onChange={() =>
                              handleCategoryChange(
                                categoryTitle
                              )
                            }
                            className="sr-only"
                          />

                          <span
                            className={`
                              flex
                              h-5
                              w-5
                              shrink-0
                              items-center
                              justify-center
                              rounded-md
                              border
                              transition-all
                              ${
                                checked
                                  ? "border-indigo-400 bg-indigo-500"
                                  : "border-slate-300 bg-white dark:border-gray-600 dark:bg-black/20"
                              }
                            `}
                          >
                            {checked && (
                              <svg
                                className="h-3 w-3 text-white"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="3"
                              >
                                <path
                                  d="m5 12 4 4L19 6"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            )}
                          </span>

                          <span
                            className={`
                              min-w-0
                              flex-1
                              truncate
                              text-xs
                              font-semibold
                              ${
                                checked
                                  ? "text-indigo-700 dark:text-white"
                                  : "text-slate-600 dark:text-gray-300"
                              }
                            `}
                          >
                            {categoryTitle}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            </aside>

            {/* =====================================================
                MOBILE FIXED CATEGORY BAR
                ONLY ONE MOBILE MENU
            ===================================================== */}
            <div
              className="
                fixed
                bottom-2
                left-2
                right-2
                z-[9999]
                overflow-hidden
                rounded-[22px]
                border
                border-slate-200/90
                bg-white/95
                px-2
                py-1.5
                shadow-[0_10px_35px_rgba(15,23,42,0.16)]
                backdrop-blur-2xl
                lg:hidden
                dark:border-white/[0.08]
                dark:bg-[#08050d]/95
                dark:shadow-[0_-10px_35px_rgba(0,0,0,0.48)]
              "
            >
              <div
                className="
                  flex
                  gap-1.5
                  overflow-x-auto
                  px-0.5
                  py-0.5
                "
                style={{
                  scrollbarWidth: "none",
                  WebkitOverflowScrolling: "touch",
                  touchAction: "pan-x",
                }}
              >
                {/* ALL */}
                <button
                  type="button"
                  onClick={handleClearCategories}
                  className={`
                    flex
                    min-h-[35px]
                    shrink-0
                    items-center
                    gap-1.5
                    rounded-full
                    border
                    px-3
                    text-[9.5px]
                    font-extrabold
                    whitespace-nowrap
                    transition-all
                    active:scale-[0.96]
                    ${
                      selectedCategories.length === 0
                        ? "border-[#6366f1] bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-[0_5px_16px_rgba(99,102,241,0.25)]"
                        : "border-slate-200 bg-slate-50 text-slate-600 dark:border-white/[0.07] dark:bg-white/[0.025] dark:text-white/60"
                    }
                  `}
                >
                  Hamısı
                </button>

                {/* CATEGORIES */}
                {categories.map((category) => {
                  const categoryTitle = category?.title;

                  if (!categoryTitle) {
                    return null;
                  }

                  const checked =
                    selectedCategories.includes(
                      categoryTitle
                    );

                  return (
                    <button
                      key={`mobile-${String(
                        category._id || categoryTitle
                      )}`}
                      type="button"
                      onClick={() =>
                        handleCategoryChange(
                          categoryTitle
                        )
                      }
                      className={`
                        flex
                        min-h-[35px]
                        shrink-0
                        items-center
                        gap-1.5
                        rounded-full
                        border
                        px-3
                        text-[9.5px]
                        font-extrabold
                        whitespace-nowrap
                        transition-all
                        active:scale-[0.96]
                        ${
                          checked
                            ? "border-[#6366f1] bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-[0_5px_16px_rgba(99,102,241,0.25)]"
                            : "border-slate-200 bg-slate-50 text-slate-600 hover:border-indigo-300 dark:border-white/[0.07] dark:bg-white/[0.025] dark:text-white/60"
                        }
                      `}
                    >
                      {categoryTitle}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* =====================================================
                PRODUCTS HEADER
            ===================================================== */}
            <div
              className="
                flex
                flex-col
                gap-2.5
                px-3.5
                pb-3
                pt-4

                sm:flex-row
                sm:items-center
                sm:justify-between
                sm:px-6
                sm:pb-4
                sm:pt-6

                lg:px-8
                lg:pb-5
                lg:pt-7
              "
            >
              <div>
                <h2
                  className="
                    text-lg
                    font-black
                    text-slate-900
                    sm:text-2xl
                    dark:text-white
                  "
                >
                  Məhsullar
                </h2>

                <p
                  className="
                    mt-0.5
                    text-[10px]
                    text-slate-500
                    sm:text-xs
                    dark:text-gray-500
                  "
                >
                  {selectedCategories.length > 0
                    ? `${selectedCategories.length} kateqoriya seçilib`
                    : "Bütün kateqoriyalardan məhsullar"}
                </p>
              </div>

              <div
                className="
                  w-fit
                  rounded-xl
                  border
                  border-slate-200
                  bg-slate-50
                  px-3
                  py-1.5
                  text-[10px]
                  text-slate-500
                  sm:px-4
                  sm:py-2
                  sm:text-xs
                  dark:border-white/[0.08]
                  dark:bg-white/[0.025]
                  dark:text-gray-400
                "
              >
                Göstərilir:{" "}
                <span
                  className="
                    font-bold
                    text-slate-900
                    dark:text-white
                  "
                >
                  {displayedProducts.length}
                </span>{" "}
                / {allProducts.length}
              </div>
            </div>

            {/* =====================================================
                PRODUCTS
                EXTRA MOBILE BOTTOM PADDING
            ===================================================== */}
            <div
              className="
                px-3.5
                pb-24
                sm:px-6
                sm:pb-8
                lg:px-8
                lg:pb-8
              "
            >
              {/* ===================================================
                  LOADING
              =================================================== */}
              {loadingProducts ? (
                <div
                  className="
                    flex
                    min-h-[260px]
                    flex-col
                    items-center
                    justify-center
                    text-center
                  "
                >
                  <div
                    className="
                      mb-4
                      flex
                      h-12
                      w-12
                      items-center
                      justify-center
                      rounded-2xl
                      border
                      border-indigo-200
                      bg-indigo-50
                      dark:border-indigo-500/20
                      dark:bg-indigo-500/10
                    "
                  >
                    <svg
                      className="h-6 w-6 animate-spin text-indigo-400"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="9"
                        stroke="currentColor"
                        strokeWidth="3"
                        opacity="0.25"
                      />

                      <path
                        d="M21 12a9 9 0 0 1-9 9"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>

                  <p
                    className="
                      text-sm
                      font-semibold
                      text-slate-600
                      dark:text-gray-300
                    "
                  >
                    Məhsullar yüklənir...
                  </p>

                  <p
                    className="
                      mt-1
                      text-[10px]
                      text-slate-400
                      dark:text-gray-600
                    "
                  >
                    Bir neçə saniyə çəkə bilər
                  </p>
                </div>
              ) : error ? (
                /* =================================================
                   ERROR
                ================================================= */
                <div
                  className="
                    flex
                    min-h-[260px]
                    flex-col
                    items-center
                    justify-center
                    text-center
                  "
                >
                  <div
                    className="
                      mb-4
                      flex
                      h-12
                      w-12
                      items-center
                      justify-center
                      rounded-2xl
                      border
                      border-rose-500/20
                      bg-rose-500/10
                      text-xl
                      text-rose-400
                    "
                  >
                    !
                  </div>

                  <p
                    className="
                      text-sm
                      font-bold
                      text-rose-400
                    "
                  >
                    {error}
                  </p>

                  <button
                    type="button"
                    onClick={() => {
                      if (
                        selectedCategories.length > 0
                      ) {
                        fetchSelectedCategoriesProducts(
                          selectedCategories
                        );
                      } else {
                        fetchRandomProducts();
                      }
                    }}
                    className="
                      mt-4
                      rounded-xl
                      bg-indigo-500
                      px-5
                      py-2.5
                      text-xs
                      font-bold
                      text-white
                      transition
                      hover:bg-indigo-400
                    "
                  >
                    Yenidən yoxla
                  </button>
                </div>
              ) : allProducts.length === 0 ? (
                /* =================================================
                   EMPTY
                ================================================= */
                <div
                  className="
                    flex
                    min-h-[260px]
                    flex-col
                    items-center
                    justify-center
                    text-center
                  "
                >
                  <div className="mb-4 text-4xl">
                    📦
                  </div>

                  <p
                    className="
                      text-sm
                      font-bold
                      text-slate-600
                      dark:text-gray-300
                    "
                  >
                    Məhsul tapılmadı.
                  </p>

                  <p
                    className="
                      mt-1
                      text-[10px]
                      text-slate-400
                      dark:text-gray-600
                    "
                  >
                    Başqa kateqoriya seçməyi yoxlayın.
                  </p>
                </div>
              ) : (
                <>
                  {/* =================================================
                      PRODUCT GRID
                  ================================================= */}
                  <div
                    className="
                      grid
                      grid-cols-2
                      gap-2.5

                      sm:grid-cols-3
                      sm:gap-4

                      lg:grid-cols-4
                      lg:gap-5

                      xl:grid-cols-5
                      2xl:grid-cols-6
                    "
                  >
                    {displayedProducts.map(
                      (product, index) => (
                        <div
                          key={String(
                            product._id ||
                              `${product.title}-${index}`
                          )}
                          className="
                            group
                            relative
                            overflow-hidden
                            rounded-[1rem]
                            border
                            border-slate-200
                            bg-white
                            shadow-[0_6px_22px_rgba(15,23,42,0.05)]
                            transition-all
                            duration-500
                            ease-out

                            hover:-translate-y-2
                            hover:border-indigo-300
                            hover:shadow-[0_22px_45px_rgba(79,70,229,0.16)]

                            sm:rounded-2xl

                            dark:border-white/[0.08]
                            dark:bg-[#0D081D]
                            dark:hover:border-fuchsia-500/50
                            dark:hover:shadow-[0_25px_60px_rgba(168,85,247,0.22)]
                          "
                        >
                          {/* =================================================
                              PREMIUM HOVER GLOW
                          ================================================= */}
                          <div
                            className="
                              pointer-events-none
                              absolute
                              inset-0
                              z-20
                              opacity-0
                              transition-opacity
                              duration-500
                              group-hover:opacity-100
                            "
                          >
                            <div
                              className="
                                absolute
                                -right-10
                                -top-10
                                h-28
                                w-28
                                rounded-full
                                bg-indigo-400/20
                                blur-3xl
                                dark:bg-fuchsia-500/20
                              "
                            />

                            <div
                              className="
                                absolute
                                -bottom-12
                                -left-10
                                h-28
                                w-28
                                rounded-full
                                bg-purple-400/20
                                blur-3xl
                                dark:bg-indigo-500/20
                              "
                            />
                          </div>

                          {/* =================================================
                              IMAGE
                          ================================================= */}
                          <div
                            className="
                              relative
                              aspect-square
                              overflow-hidden
                              bg-slate-50
                              dark:bg-[#080510]
                            "
                          >
                            <img
                              src={product.photo}
                              alt={
                                product.title ||
                                "Mobil aksesuar"
                              }
                              loading="lazy"
                              className="
                                relative
                                z-0
                                h-full
                                w-full
                                object-cover
                                transition-all
                                duration-700
                                ease-out
                                group-hover:scale-[1.09]
                                group-hover:rotate-[0.5deg]
                              "
                              onError={(event) => {
                                event.currentTarget.src =
                                  "/assets/img/ffff.png";
                              }}
                            />

                            {/* IMAGE DARKENING */}
                            <div
                              className="
                                pointer-events-none
                                absolute
                                inset-0
                                z-10
                                bg-gradient-to-t
                                from-black/35
                                via-transparent
                                to-transparent
                                transition-all
                                duration-500
                                group-hover:from-indigo-950/50
                                group-hover:via-transparent
                                dark:from-black/60
                                dark:group-hover:from-purple-950/50
                              "
                            />

                            {/* HOVER SHINE */}
                            <div
                              className="
                                pointer-events-none
                                absolute
                                -left-[120%]
                                top-0
                                z-10
                                h-full
                                w-[70%]
                                skew-x-[-18deg]
                                bg-gradient-to-r
                                from-transparent
                                via-white/20
                                to-transparent
                                transition-all
                                duration-700
                                group-hover:left-[140%]
                              "
                            />

                            {/* NUMBER */}
                            <span
                              className="
                                absolute
                                right-2
                                top-2
                                z-30
                                rounded-lg
                                border
                                border-white/10
                                bg-black/30
                                px-1.5
                                py-1
                                text-[8px]
                                font-black
                                text-white/70
                                backdrop-blur-md
                                transition-all
                                duration-300
                                group-hover:border-white/30
                                group-hover:bg-black/45
                                group-hover:text-white
                                sm:right-3
                                sm:top-3
                              "
                            >
                              {String(index + 1).padStart(
                                2,
                                "0"
                              )}
                            </span>
                          </div>

                          {/* =================================================
                              CONTENT
                          ================================================= */}
                          <div
                            className="
                              relative
                              z-30
                              p-2.5
                              sm:p-4
                            "
                          >
                            <h3
                              className="
                                line-clamp-2
                                min-h-[32px]
                                text-[11px]
                                font-extrabold
                                leading-4
                                text-slate-900
                                transition-colors
                                duration-300
                                group-hover:text-indigo-600

                                sm:min-h-[40px]
                                sm:text-base
                                sm:leading-5

                                dark:text-white
                                dark:group-hover:text-fuchsia-300
                              "
                              title={product.title}
                            >
                              {product.title}
                            </h3>

                            {/* PRICE */}
                            <div
                              className="
                                mt-2
                                flex
                                items-center
                                justify-between
                                gap-1.5
                                sm:mt-3
                              "
                            >
                              <span
                                className="
                                  text-sm
                                  font-black
                                  text-indigo-600
                                  transition-all
                                  duration-300
                                  group-hover:text-purple-600
                                  sm:text-lg
                                  dark:text-indigo-400
                                  dark:group-hover:text-fuchsia-300
                                "
                              >
                                {product.price} ₼
                              </span>
                            </div>

                            {/* =================================================
                                ORDER BUTTON
                            ================================================= */}
                            <button
                              type="button"
                              onClick={() =>
                                handleOrder(product)
                              }
                              className="
                                relative
                                mt-2.5
                                flex
                                min-h-[36px]
                                w-full
                                items-center
                                justify-center
                                gap-1.5
                                overflow-hidden
                                rounded-lg
                                bg-gradient-to-r
                                from-indigo-500
                                to-purple-600
                                text-[9px]
                                font-black
                                text-white
                                shadow-[0_6px_18px_rgba(99,102,241,0.16)]
                                transition-all
                                duration-300
                                hover:from-indigo-400
                                hover:to-fuchsia-500
                                hover:shadow-[0_8px_25px_rgba(139,92,246,0.35)]
                                active:scale-[0.96]

                                sm:mt-3
                                sm:min-h-[42px]
                                sm:gap-2
                                sm:rounded-xl
                                sm:text-sm
                              "
                            >
                              {/* SHINE */}
                              <span
                                className="
                                  pointer-events-none
                                  absolute
                                  inset-0
                                  -translate-x-full
                                  bg-gradient-to-r
                                  from-transparent
                                  via-white/20
                                  to-transparent
                                  transition-transform
                                  duration-700
                                  group-hover:translate-x-full
                                "
                              />

                              {/* WHATSAPP ICON */}
                              <svg
                                className="
                                  relative
                                  z-10
                                  h-3.5
                                  w-3.5
                                  sm:h-4
                                  sm:w-4
                                "
                                viewBox="0 0 24 24"
                                fill="currentColor"
                              >
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.198.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.845 1.213 3.043.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />

                                <path d="M12.004 2C6.478 2 2 6.477 2 12c0 1.768.46 3.43 1.266 4.877L2 22l5.243-1.238A9.956 9.956 0 0 0 12.004 22C17.523 22 22 17.523 22 12S17.523 2 12.004 2zm0 18.001a8.34 8.34 0 0 1-4.257-1.167l-.305-.182-3.113.735.741-3.035-.199-.312A8.34 8.34 0 1 1 12.004 20z" />
                              </svg>

                              <span className="relative z-10">
                                Sifariş et
                              </span>
                            </button>
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  {/* =================================================
                      LOAD MORE
                  ================================================= */}
                  {displayedCount <
                    allProducts.length && (
                    <div
                      className="
                        mt-6
                        flex
                        justify-center
                        sm:mt-8
                      "
                    >
                      <button
                        type="button"
                        onClick={handleLoadMore}
                        className="
                          flex
                          items-center
                          gap-2.5
                          rounded-xl
                          border
                          border-indigo-200
                          bg-indigo-50
                          px-6
                          py-2.5
                          text-xs
                          font-black
                          text-indigo-700
                          transition-all
                          active:scale-[0.97]
                          hover:border-indigo-300
                          hover:bg-indigo-100

                          sm:rounded-2xl
                          sm:px-8
                          sm:py-3
                          sm:text-sm

                          dark:border-indigo-500/30
                          dark:bg-indigo-500/10
                          dark:text-white
                          dark:hover:border-indigo-400/50
                          dark:hover:bg-indigo-500/20
                        "
                      >
                        Daha Çox

                        <svg
                          className="h-4 w-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path
                            d="M12 5v14M19 12l-7 7-7-7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default MobileAccessory;